/*eslint-disable*/
export default [
    {
        path: '/battles',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/Layout.vue'),
        children: [
            {
                path: '',
                name: 'battles:index',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/battles/List.vue'),
                meta: {
                    title: 'router.router_battles',
                    emptyContent: true,
                    prev: {
                        name: 'dashboard'
                    }
                },
                props ($route) {
                    return {
                        page: $route.query.page,
                    }
                }
            },
            {
                path: '/battles/achievements-list',
                name: 'battle:achievements-list',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/achievements/AchievementsList.vue'),
                meta: {
                    title: 'router.router_battleAchievementsList',
                    emptyContent: true,
                    prev: {
                        name: 'dashboard'
                    }
                }
            },
            {
                path: '/battles/bad-connection',
                name: 'battle:bad-connection',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/BadConnection.vue'),
                meta: {
                    title: 'router.router_battle',
                    emptyContent: true,
                },
                props: true
            },
            {
                path: '/battles/select-game-type',
                name: 'battles:main',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/select-game-type/SelectGameType.vue'),
                meta: {
                    title: 'router.router_battles',
                    emptyContent: true,
                    prev: {
                        name: 'dashboard'
                    }
                },
            },
            {
                path: '/battles/opponent',
                name: 'battles:opponent',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/opponent/Main.vue'),
                meta: {
                    title: 'router.router_findOpponent',
                    emptyContent: true,
                    prev: {
                        name: 'battles:index'
                    }
                },
                props: true
            },
            {
                path: '/battles/opponents',
                name: 'battles:opponents',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/battles/ListOpponents.vue'),
                meta: {
                    title: 'router.router_chooseOpponent',
                    emptyContent: true,
                    prev: {
                        name: 'battles:index'
                    }
                },
                props: true
            },
            {
                path: ':id/play',
                name: 'battle:start',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/GamePage.vue'),
                meta: {
                    title: 'router.router_battle',
                    emptyContent: true,
                    prev: {
                        name: 'battles:index'
                    }
                },
                props: true
            },
            {
                path: ':id/result',
                name: 'battle:result',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/result/Main.vue'),
                meta: {
                    title: 'router.router_battleResult',
                    emptyContent: true,
                    prev: {
                        name: 'battle:index'
                    }
                },
                props: true
            },
            {
                path: ':id',
                name: 'battle:show',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/ShowPage.vue'),
                meta: {
                    title: 'router.router_battle',
                    emptyContent: true,
                    battleTitle: 'battle'
                },
                props: true
            },
            {
                path: ':id/register',
                name: 'battle:register',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/olympiad/RegisterPage.vue'),
                meta: {
                    title: 'router.router_battleRegistration',
                    emptyContent: true,
                    battleTitle: 'battle'
                },
                props: true
            },
        ],
    },
    {
        path: 'battle/create',
        name: 'battle:form',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/Create.vue'),
        meta: {
            title: 'router.router_battle',
            prev: {
                name: 'battles:index'
            }
        }
    },
    {
        path: 'battle/:battleId/edit',
        name: 'battle:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/Edit.vue'),
        meta: {
            title: 'router.router_editBattle',
            prev: {
                name: 'battles:index'
            }
        },
        props: true
    },
    {
        path: 'battle/:battleId?/level/:index/create',
        name: 'battle-level:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/EditLevel.vue'),
        meta: {
            title: 'router.router_editLevel',
            prev ($route) {
                return { name: $route.params.battleId ? 'battle:edit' : 'battle:form' }
            }
        },
        props ($route) {
            return {
                index: $route.params.index,
                battleId: $route.params.battleId
            }
        }
    },
    {
        path: 'battle/:battleId?/level/:index/stage/:stageId/game/:id/edit/:generatorSettings?/:generatorGameIndex?',
        name: 'battle-stage-game:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/GameEdit.vue'),
        meta: {
            title: 'router.router_editOlympiadGame',
            prev: {
                name: 'battle-level:create'
            }
        },
        props: true
    },
    {
        path: '/battle-trainings',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/Layout.vue'),
        children: [
            {
                path: '',
                name: 'battle-trainings:index',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/trainings/List.vue'),
                meta: {
                    title: 'router.router_trainings',
                    emptyContent: true,
                    prev: {
                        name: 'dashboard'
                    }
                },
                props ($route) {
                    return {
                        page: $route.query.page,
                        isTrainer: true
                    }
                }
            }
        ]
    },
    {
        path: '/battle-training/opponents',
        name: 'battles-training:opponents',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/trainings/ListOpponnents.vue'),
        meta: {
            title: 'router.router_chooseOpponent',
            emptyContent: true,
            prev: {
                name: 'trainings'
            }
        },
        props: true
    },
    {
        path: 'battle-training/create',
        name: 'battle-training:form',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/trainings/Create.vue'),
        meta: {
            title: 'router.router_training',
            prev: {
                name: 'battle-trainings:index'
            }
        },
        props() {
            return {
                isTrainer: true
            }
        }
    },
    {
        path: 'battle-training/:battleId/edit',
        name: 'battle-training:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/Edit.vue'),
        meta: {
            title: 'router.router_editTraining',
            prev: {
                name: 'battle-trainings:index'
            }
        },
        props: true
    },

    {
        path: 'battle-training/:battleId?/level/:index/create',
        name: 'battle-training-level:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/EditLevel.vue'),
        meta: {
            title: 'router.router_editLevel',
            prev ($route) {
                return {
                    name: $route.params.battleId
                            ? 'battle-training:edit'
                            : 'battle-training:form',
                }
            }
        },
        props ($route) {
            return {
                index: $route.params.index,
                battleId: $route.params.battleId,
                isTrainer: true
            }
        }
    },
    {
        path: 'battle-training/:battleId?/level/:index/stage/:stageId/game/:id/edit/:generatorSettings?/:generatorGameIndex?',
        name: 'battle-training-stage-game:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "battle" */'../../components/mental-battle/GameEdit.vue'),
        meta: {
            title: 'router.router_editOlympiadGame',
            prev: {
                name: 'battle-training-level:create'
            }
        },
        props: true
    },
];
